// extracted by mini-css-extract-plugin
export default {"content":"ContractTerminationConfirmationModal_content__jx8Mr"};